module.exports = __webpack_public_path__ + "resources/img/img_security_shellcop_en.bae2830df91ec87a81705222efb7e4f8.png";